module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp13_7016.c5309b71.png";